export default class SmsLanding {
  constructor(component) {
    this.dom = {
      $component: component,
      iframe: component.querySelector('.js-sms-landing-iframe'),
      failMsg: component.querySelector('.js-sms-landing-fail-message'),
      hiddenHeroMessage: document.querySelector('.js-sms-landing-hidden-message'),
    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    this.loadSmsLanding()
  }

  loadSmsLanding() {
    const { dom } = this
    const country = window.Shopify.country.toLowerCase()
    dom.$component.dataset.smsLocale = country

    const smsLandingUrl = dom.$component.dataset[`${country}SmsUrl`]
    if (!smsLandingUrl || (country !== 'ca' && country !== 'us')) {
      dom.hiddenHeroMessage.style.display = 'block'
      dom.$component.style.display = 'none'
      return
    }

    dom.iframe.src = smsLandingUrl
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.SmsLanding = this
  }
}
